<!-- Etapa e título à esquerda; saldo geral da conta à direita. -->
<div class="cabecalho">
  <div>
    <app-steps [current]="stepAtual()" [total]="totalSteps()"></app-steps>
    <h2 class="title">Configure seu benefício</h2>
  </div>
  <div class="saldo-geral">
    <p class="saldo-geral__rotulo">Saldo geral da conta</p>
    <p class="saldo-geral__valor"><span class="moeda">R$</span> {{ formatarValor(saldoGeral()) }}</p>
  </div>
</div>
<div>
  <form [formGroup]="form">
    <!-- Só quando o plano permite antecipação de saldo. -->
    @if (limites().permiteAntecipacao) {
      <app-card-conteudo
        class="top-32"
        titulo="Antecipação de saldo à vista (Opcional)"
        [descricao]="
          'O percentual deve ser entre ' +
          percentualMinimoAntecipacao() +
          '% e ' +
          percentualMaximoAntecipacao() +
          '%'
        "
      >
        <div cardAcao class="campo-percentual">
          <vivest-input
            formControlName="percentualAntecipacao"
            vivestFormat="digits"
            [vivestMaxLength]="2"
            label=""
            aria-label="Percentual de antecipação"
            [placeholder]="'Máximo: ' + percentualMaximoAntecipacao()"
            name="percentualAntecipacao"
            type="text"
            icon="percent"
            [status]="status('percentualAntecipacao')"
            [errorMessage]="mensagemErro('percentualAntecipacao')"
          >
          </vivest-input>
          <p class="resultado">
            Valor: R$
            <span class="resultado-valor">{{ formatarValor(valorAntecipacao()) }}</span>
          </p>
        </div>
      </app-card-conteudo>
    }

    <!-- Some quando o plano não oferece forma de recebimento nem adiantamento. -->
    @if (opcoesRecebimento().length > 0 || limites().elegivelAdiantamento) {
      <app-card-conteudo class="top-64" titulo="Como você deseja receber seu benefício?">
        <div
          class="opcoes-recebimento"
          role="radiogroup"
          aria-label="Forma de recebimento do benefício"
        >
          @for (opcao of opcoesRecebimento(); track opcao.value) {
            <!-- Clicar em qualquer parte do card seleciona a opção, não só no radio. -->
            <div
              class="opcao-card"
              [class.opcao-card--selecionada]="formaRecebimento() === opcao.value"
              (click)="formaRecebimento.set(opcao.value)"
            >
              <vivest-radio
                label-variant="multi-line"
                name="forma-recebimento"
                [value]="opcao.value"
                [checked]="formaRecebimento() === opcao.value"
                (change)="formaRecebimento.set(opcao.value)"
              >
                {{ opcao.titulo }}
              </vivest-radio>
              <span class="opcao-card__descricao">{{ opcao.descricao }}</span>
            </div>
          }
        </div>

        <!-- Pergunta e campo só da forma oferecida pelo plano; sem nenhuma, não há o que preencher. -->
        @if (formaPermitida()) {
          @switch (formaRecebimento()) {
            @case ('valor-fixo-mensal') {
              <div class="pergunta-recebimento">
                <div>
                  <h4 class="pergunta-titulo">Qual valor deseja receber mensalmente?</h4>
                </div>
                <div class="campo-percentual">
                  <vivest-input
                    formControlName="valorMensal"
                    vivestFormat="moeda"
                    label=""
                    aria-label="Valor mensal desejado"
                    placeholder="R$ 0,00"
                    name="valorMensal"
                    type="text"
                    icon="dollar-sign"
                    [status]="status('valorMensal')"
                    [errorMessage]="mensagemErro('valorMensal')"
                  ></vivest-input>
                  <p class="resultado">
                    Duração estimada do benefício:
                    <span class="resultado-valor">{{ simulacao().duracaoEstimadaAnos }} anos</span>
                  </p>
                </div>
              </div>
            }
            @case ('percentual-saldo') {
              <div class="pergunta-recebimento">
                <div>
                  <h4 class="pergunta-titulo">Qual porcentagem do seu saldo quer receber por mês?</h4>
                  <p class="pergunta-descricao">
                    O percentual deve ser entre {{ percentualMinimoMensal() }}% e {{ percentualMaximoMensal() }}%
                  </p>
                </div>
                <div class="campo-percentual">
                  <vivest-input
                    formControlName="percentualMensal"
                    vivestFormat="digits"
                    [vivestMaxLength]="2"
                    label=""
                    aria-label="Percentual mensal do saldo"
                    [placeholder]="'Máximo: ' + percentualMaximoMensal()"
                    name="percentualMensal"
                    type="text"
                    icon="percent"
                    [status]="status('percentualMensal')"
                    [errorMessage]="mensagemErro('percentualMensal')"
                  ></vivest-input>
                  <p class="resultado">
                    Duração estimada do benefício:
                    <span class="resultado-valor">{{ simulacao().duracaoEstimadaAnos }} anos</span>
                  </p>
                  <p class="resultado">
                    Valor mensal equivalente:
                    <span class="resultado-valor">{{
                      formatarValor(simulacao().valorMensalEquivalente)
                    }}</span>
                  </p>
                </div>
              </div>
            }
            @case ('prazo-certo') {
              <div class="pergunta-recebimento">
                <div>
                  <h4 class="pergunta-titulo">Por quantos anos deseja receber sua aposentadoria?</h4>
                  <p class="pergunta-descricao">
                    Tempo mínimo de {{ prazoMinimoAnos() }} anos e tempo máximo de
                    {{ prazoMaximoAnos() }} anos
                  </p>
                </div>
                <div class="campo-percentual">
                  <vivest-input
                    formControlName="prazoAnos"
                    vivestFormat="digits"
                    [vivestMaxLength]="2"
                    label=""
                    aria-label="Prazo de recebimento em anos"
                    [placeholder]="prazoMinimoAnos() + ' - ' + prazoMaximoAnos()"
                    name="prazoAnos"
                    type="text"
                    icon="custom"
                    [status]="status('prazoAnos')"
                    [errorMessage]="mensagemErro('prazoAnos')"
                  >
                    <span slot="icon" class="sufixo">anos</span>
                  </vivest-input>
                  <p class="resultado">
                    Valor mensal equivalente: R$
                    <span class="resultado-valor">{{
                      formatarValor(simulacao().valorMensalEquivalente)
                    }}</span>
                  </p>
                </div>
              </div>
            }
          }
        }

        <!-- Vale para qualquer forma de recebimento: fica abaixo da pergunta da modalidade escolhida. Só para quem o
          plano considera elegível ao adiantamento. -->
        @if (limites().elegivelAdiantamento) {
          <div class="adiantamento">
            <vivest-checkbox
              label-variant="single-line"
              name="adiantamento-beneficio"
              [checked]="adiantamentoBeneficio()"
              (change)="onAdiantamentoChange($event)"
            >
              Adiantamento de benefício
            </vivest-checkbox>
          </div>
        }
      </app-card-conteudo>
    }

    <div class="d-flex justify-content-center align-items-center buttons-requerimento">
      <vivest-button variant="outline" size="md" (click)="onReturn()"> Voltar </vivest-button>
      <vivest-button variant="primary" size="md" [disabled]="!podeContinuar()" (click)="onSubmit()">
        <vivest-icon slot="icon-right" name="arrow-right" source="feather"></vivest-icon>
        Continuar para Imposto de Renda
      </vivest-button>
    </div>
  </form>
</div>
